import { useMutation } from "@tanstack/react-query";

import api from "@/api/api";
import type {
  ForgotPasswordForm,
  LoginForm,
  RegisterForm,
  ResetPasswordForm,
} from "@/schemas/auth";
import type { Login, User } from "@/types/api/user";

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: (data: ForgotPasswordForm) =>
      api.post("/auth/request-password-reset", data),
  });
};

export const useResetPassword = () => {
  return useMutation({
    mutationFn: (data: ResetPasswordForm) =>
      api.post("/auth/reset-password", data),
  });
};

const login = async (data: LoginForm) => {
  const res = await api.post<Login>("/auth/login", data);
  return res.data;
};

export const useLogin = () => {
  return useMutation({
    mutationFn: login,
  });
};

const register = async (data: RegisterForm) => {
  const res = await api.post<User>("/auth/signup", data);
  return res.data;
};

export const useRegister = () => {
  return useMutation({
    mutationFn: register,
  });
};
